import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { CloseOutlined, ShoppingCartOutlined } from "@material-ui/icons";
import { Color } from "@material-ui/lab/Alert";
import { useUser } from "@saleor/auth";
import Checkbox from "@saleor/components/Checkbox";
import DecimalFormat from "@saleor/components/DecimalFormat";
import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat/NumberFormat";
import SnackbarAlert from "@saleor/components/SnackbarAlert";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { STAFF_UPDATE } from "@saleor/config";
import { VariantStandard } from "@saleor/createOrder/const";
import { orderCart } from "@saleor/createOrder/urls";
import {
  useAddProductsToDomesticOrderMutation,
  useAddProductToCustomerOrderMutation,
  useCartTotalCheckoutQuery,
  useContractProductQuery,
  useCreateContractCheckoutMutation,
  useCreateCustomerCartMutation,
  useCustomerCartsQuery,
  useCustomerCartTotalsQuery,
  useCustomerContractProductQuery,
  useUpdateCustomerCartMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
// import { PROD_CATEG_2 } from "@saleor/utils/constants";
import classNames from "classnames";
import lodash_find from "lodash/find";
import React, { useEffect, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl/lib";
import { useLocation } from "react-router";

export interface ModalProductDetailProps {
  userId: string;
  contractId: string;
  orderId?: string;
  productId: string;
  contractMaterialId?: string;
  onClose?: () => void;
  open?: boolean;
  onAddProductComplete: () => void; // pass ()=>null if not using
  onAddProduct?: () => boolean; // pass ()=>null if not using
  handleAddMoreData?: (data) => void;
  staffUpdate?: number;
  cartId?: string;
  isHideShowStandard?: boolean;
  isCreateOrderFlow?: boolean;
  isChangeOrderFlow?: boolean;
  remainInCart?: number;
  // remainInCartCateg2?: number;
  remainInChangeOrder?: number;
  cartData?: any;
  customerCart?: any;
  soNo?: string;
  prodErrorContent?: any;
  setPopUpContent?: (e: any) => void;
  setVisibleDialogError?: (e: boolean) => void;
  testId?: string;
}

const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "right",
      padding: "20px 20px 10px 0"
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 640,
        width: "100%",
        borderRadius: 16,
        marginTop: 50
      },
      "& .MuiDialogContent-root": {
        paddingTop: 0
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 24
      },
      "& .MuiDialog-container": {
        alignItems: "flex-start"
      },
      "& *": {
        fontFamily: "ScgFont, sans-serif",
        letterSpacing: 0
      }
    },
    materialName: {
      fontSize: 20,
      fontWeight: 700,
      color: theme.palette.info.main,
      marginBottom: 20
    },
    detailTitle: {
      fontWeight: 700,
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal",
        display: "inline-block",
        padding: "0 2px"
      },
      color: theme.palette.grey[900],
      fontSize: "1.2rem"
    },
    detailValue: {
      fontWeight: 400,
      color: theme.palette.grey[900],
      fontSize: "1.4rem"
    },
    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto"
    },
    variantName: {
      fontSize: "1.4rem"
    },
    textNumberSelect: {
      textAlign: "right",
      fontSize: "1.6rem",
      color: theme.palette.grey[900],
      fontWeight: 400
    },
    textNumber: {
      fontWeight: 700,
      display: "inline-block",
      padding: "0 5px"
    },
    tableRoot: {
      margin: "15px 0",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: 4,
      color: theme.palette.grey[900]
    },
    cellCheckbox: {
      padding: "0 5px !important"
    },
    cellInput: {
      padding: "0 5px !important"
    },
    cellName: {
      padding: "0 10px !important",
      color: theme.palette.grey[900]
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    textAdd: {
      fontWeight: 700,
      fontSize: 16
    },
    textAlert: {
      fontWeight: 400,
      fontSize: 14
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    boldText: {
      fontWeight: 700
    },
    normalText: {
      fontWeight: 400
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    tableLoading: {
      opacity: 0.5,
      pointerEvents: "none"
    },
    tableHeaderLoading: {
      "&.MuiTableCell-root.MuiTableCell-head": {
        height: "4px",
        padding: "0px"
      }
    }
  }),
  { name: "ModalProductDetail" }
);

const ModalProductDetail: React.FC<ModalProductDetailProps> = props => {
  const {
    open,
    onClose,
    productId,
    contractId,
    orderId,
    contractMaterialId,
    userId,
    isHideShowStandard,
    onAddProductComplete,
    onAddProduct,
    staffUpdate,
    isCreateOrderFlow,
    isChangeOrderFlow,
    remainInCart = 0,
    // remainInCartCateg2 = 0,
    remainInChangeOrder = null,
    cartId,
    handleAddMoreData,
    cartData,
    customerCart,
    soNo,
    prodErrorContent,
    setPopUpContent,
    setVisibleDialogError,
    testId
  } = props;
  const [listVariantState, setListVariantState] = useState([]);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [typeAlert, setTypeAlert] = useState<Color>("success");
  const [loadingAddCart, setLoadingAddCart] = useState<boolean>(false);
  const [, dispatchAppState] = useAppState();
  const [splitedData, setSplitedData] = useState({
    standard: [],
    nonStandard: []
  });
  const classes = useStyles();
  const intl = useIntl();
  const { user, soldToId } = useUser();
  const location = useLocation();

  const { data, loading } = useContractProductQuery({
    variables: {
      productId,
      contractId,
      contractMaterialId: contractMaterialId || undefined,
      soNo: soNo || ""
    },
    skip: !open || !productId || !contractId || !user.isStaff
  });

  const {
    data: dataCustomer,
    loading: loadingCustomer
  } = useCustomerContractProductQuery({
    variables: {
      productId,
      contractId,
      contractMaterialId: contractMaterialId || undefined,
      orderId: staffUpdate === STAFF_UPDATE.UPDATE_ORDER ? cartId : undefined
    },
    skip: !open || !productId || !contractId || user.isStaff
  });

  const { refetch: refetchCart } = useCartTotalCheckoutQuery({
    skip: true
  });

  const { refetch: refetchCartCustomer } = useCustomerCartTotalsQuery({
    skip: true,
    variables: {
      soldToId
    },
    fetchPolicy: "no-cache"
  });

  const { refetch: customerCartsRefetch } = useCustomerCartsQuery({
    variables: {
      first: 100,
      soldToId
    },
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    if (user.isStaff) {
      if (data?.contractProduct?.product && !loading) {
        const mapFromProps = [...data.contractProduct.product.variants].map(
          variant => ({
            ...variant,
            quantity: "",
            selected: false,
            errorQuantity: false,
            reset: false
          })
        );
        const standard = mapFromProps.filter(
          e => e.variantType === VariantStandard.Standard
        );
        const nonStandard = mapFromProps.filter(
          e => e.variantType === VariantStandard.NonStandard
        );
        setSplitedData({
          standard,
          nonStandard
        });
        setListVariantState(mapFromProps);
      }
    }
  }, [data, loading]);

  useEffect(() => {
    if (!user.isStaff) {
      if (dataCustomer?.customerContractProduct?.product && !loading) {
        const mapFromProps = [
          ...dataCustomer.customerContractProduct.product.variants
        ].map(variant => ({
          ...variant,
          quantity: "",
          selected: false,
          errorQuantity: false,
          reset: false,
          contractProductId: dataCustomer?.customerContractProduct?.id
        }));
        setListVariantState(mapFromProps);
      }
    }
  }, [dataCustomer, loadingCustomer]);

  const customerVariantStandard = useMemo(
    () =>
      listVariantState.filter(
        item => item.variantType === VariantStandard.Standard
      ),
    [listVariantState]
  );

  const customerVariantNonStandard = useMemo(
    () =>
      listVariantState.filter(
        item => item.variantType === VariantStandard.NonStandard
      ),
    [listVariantState]
  );

  const reCountCartDomestic = response => {
    if (response?.data?.totalContractCheckouts?.totalProducts) {
      const orderCount =
        response?.data?.totalContractCheckouts?.totalProducts || 0;
      dispatchAppState({
        payload: {
          orderCount
        },
        type: "setOrderCount"
      });
    }
  };

  const reCountCartCustomer = response => {
    if (response?.data?.customerCartTotals?.totalProducts) {
      const orderCount = response?.data?.customerCartTotals?.totalProducts || 0;
      dispatchAppState({
        payload: {
          orderCount
        },
        type: "setOrderCount"
      });
    }
  };

  const [addToCart] = useCreateContractCheckoutMutation();

  const [creatCartCustomer] = useCreateCustomerCartMutation();

  const [updateCartCustomer] = useUpdateCustomerCartMutation();

  const [addCustomerOrder] = useAddProductToCustomerOrderMutation();

  const [addProductToDomesticOrder] = useAddProductsToDomesticOrderMutation();

  const [isChangeOrderLineUpdated, setChangeOrderLineUpdated] = useState<
    boolean
  >(false);

  const onClickClear = () => {
    const listChange = [...listVariantState];
    listChange.forEach(item => {
      item.selected = false;
      item.reset = true;
      item.errorQuantity = false;
    });
    setListVariantState(listChange);
  };

  const getTotalQuantityInput = (countNotSelected: boolean = false) => {
    let amountTotal = 0;

    listVariantState.forEach(item => {
      if (location.pathname.includes(orderCart)) {
        if (cartData) {
          cartData.map(data => {
            if (
              data.contractProduct.id === item.contractProductId &&
              data.variant.id === item.id
            ) {
              amountTotal += data.quantity * data.weightPerUnit;
            }
          });
        }
        amountTotal += (Number(item.quantity) || 0) * item.weight;
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const totalCalculateAmount = customerCart?.customerCart?.cartItems?.map(
          cart => {
            const filtered = lodash_find(cartData, {
              contractProduct: {
                product: { id: cart.contractProduct.product.id }
              }
            });

            if (filtered) {
              if (
                item.id === cart.variant.id &&
                item.id === filtered.variant.id
              ) {
                amountTotal += filtered.quantity * item.weight;
              } else {
                if (item.id === cart.variant.id) {
                  amountTotal += cart.quantity * item.weight;
                }
              }
            }
          }
        );

        if (!item.quantity) {
          amountTotal += 0;
        } else {
          if (countNotSelected) {
            amountTotal += parseFloat(item.quantity) * item.weight;
          } else {
            if (item.selected) {
              amountTotal += parseFloat(item.quantity) * item.weight;
            }
          }
        }
      }
    });
    return amountTotal;
  };

  const onChangeCheckItem = (e, id) => {
    /*  const isStaff = user.isStaff;
    if (isStaff) {
      onChangeCheckItemDomestic(e, id);
      return;
    } */
    const listChange = [...listVariantState];
    const itemChange = listChange.find(item => item.id === id);
    itemChange.selected = e.target.checked;
    const amountTotal = getTotalQuantityInput();
    let remain = user.isStaff
      ? data?.contractProduct?.remain
      : dataCustomer?.customerContractProduct?.remainingQuantity;
    remain = remain ? remain : 0;
    if (amountTotal > remain - remainInCart) {
      itemChange.errorQuantity = itemChange.selected;
    } else {
      listChange.forEach(item => {
        if (item.quantity) {
          item.errorQuantity = false;
        }
      });
    }
    if (!itemChange.quantity) {
      itemChange.errorQuantity = itemChange.selected;
    }
    setListVariantState(listChange);
  };

  /* const onChangeCheckItemDomestic = (e, id) => {
    const listChange = [...listVariantState];
    const itemChange = listChange.find(item => item.id === id);
    itemChange.selected = e.target.checked;
    const remain = itemChange.limitQuantity || 0;
    if (itemChange.quantity > remain) {
      itemChange.errorQuantity = itemChange.selected;
    } else {
      itemChange.errorQuantity = false;
    }
    if (!itemChange.quantity) {
      itemChange.errorQuantity = itemChange.selected;
    }
    setListVariantState(listChange);
  }; */

  const onClickCheckHeader = () => {
    /* const isStaff = user.isStaff;
    if (isStaff) {
      onClickCheckHeaderDomestic();
      return;
    } */
    const listChange = [...listVariantState];
    const listSelected = getSelectedVariant();
    let remain = user.isStaff
      ? data?.contractProduct?.remain
      : dataCustomer?.customerContractProduct?.remainingQuantity;
    remain = remain ? remain : 0;
    if (listSelected.length < listVariantState.length) {
      if (getTotalQuantityInput(true) > remain - remainInCart) {
        listChange.forEach(item => (item.errorQuantity = true));
      }
      listChange.forEach(item => {
        item.selected = true;
        if (!item.quantity) {
          item.errorQuantity = true;
        }
      });
    } else if (listSelected.length === listVariantState.length) {
      listChange.forEach(item => {
        item.selected = false;
        item.errorQuantity = false;
      });
    }
    setListVariantState(listChange);
  };

  /* const onClickCheckHeaderDomestic = () => {
    const listChange = [...listVariantState];
    const listSelected = getSelectedVariant();
    if (listSelected.length < listVariantState.length) {
      listChange.forEach(
        item => (item.errorQuantity = item.quantity > item.limitQuantity)
      );
      listChange.forEach(item => {
        item.selected = true;
        if (!item.quantity) {
          item.errorQuantity = true;
        }
      });
    } else if (listSelected.length === listVariantState.length) {
      listChange.forEach(item => {
        item.selected = false;
        item.errorQuantity = false;
      });
    }
    setListVariantState(listChange);
  }; */

  const getCheckedHeader = () => listVariantState.every(item => item.selected);

  const getIndeterminateHeader = () => {
    const listSelectedLength = getSelectedVariant().length;
    return (
      listSelectedLength > 0 && listSelectedLength < listVariantState.length
    );
  };

  const getSelectedVariant = () =>
    listVariantState.filter(item => item.selected);

  const getDisableSubmit = () => getSelectedVariant().length === 0;

  useEffect(() => {
    listVariantState.forEach(variant => {
      if (variant.selected) {
        onChangeQuantity(variant.quantity, variant.id);
      }
    });
  }, [
    remainInCart,
    isChangeOrderLineUpdated
    // remainInCartCateg2
  ]);

  const onChangeQuantity = (newQuantity, id) => {
    const listChange = [...listVariantState];
    listChange.forEach(item => (item.reset = false));

    const itemChange = listChange.find(item => item.id === id);
    itemChange.quantity = newQuantity;

    if (!!itemChange.quantity) {
      itemChange.selected = true;
    } else {
      itemChange.selected = false;
      itemChange.errorQuantity = false;
    }

    const amountTotal = getTotalQuantityInput();

    let remain = user.isStaff
      ? data?.contractProduct?.remain
      : dataCustomer?.customerContractProduct?.remainingQuantity;

    if (remainInChangeOrder) {
      remain = remainInChangeOrder;
    }
    remain = remain ? remain : 0;

    if (
      (isCreateOrderFlow && amountTotal > remain - remainInCart) ||
      (isChangeOrderLineUpdated && amountTotal > remain - remainInCart)
    ) {
      if (itemChange.quantity) {
        itemChange.errorQuantity = true;
      } else {
        itemChange.errorQuantity = false;
      }
    } else if (isChangeOrderFlow && amountTotal > remain) {
      if (itemChange.quantity) {
        itemChange.errorQuantity = true;
      } else {
        itemChange.errorQuantity = false;
      }
    } else {
      listChange.forEach(item => {
        if (!item.quantity) {
          item.errorQuantity = item.selected;
        } else {
          item.errorQuantity = false;
        }
      });
    }
    setListVariantState(listChange);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const onAutoClose = () => {
    setTimeout(onClose, 3200);
    setTimeout(handleCloseAlert, 3000);
  };

  const onClickAddToCart = async () => {
    if (listVariantState.filter(item => item.errorQuantity).length > 0) {
      setTypeAlert("error");
      setOpenAlert(true);
      return;
    }
    setLoadingAddCart(true);
    if (staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC) {
      const result = await addProductToDomesticOrder({
        variables: {
          id: orderId,
          input: getSelectedVariant().map(item => ({
            contractMaterialId: data?.contractProduct?.id,
            quantity: +item.quantity,
            materialVariantId: item.id
          }))
        }
      });
      setLoadingAddCart(false);
      if (
        result?.data?.addProductsToDomesticOrder?.errors[0]?.code ===
        "PRODUCT_GROUP_ERROR"
      ) {
        setVisibleDialogError(true);
        setPopUpContent(prodErrorContent);
        return;
      }
      if (result?.data?.addProductsToDomesticOrder?.errors?.length > 0) {
        setTypeAlert("error");
        setOpenAlert(true);
        return;
      }
      setTypeAlert("success");
      setOpenAlert(true);
      onAutoClose();
      if (handleAddMoreData) {
        handleAddMoreData(result?.data?.addProductsToDomesticOrder?.orderLines);
      }
      refetchCartCustomer().then(response => reCountCartCustomer(response));

      onAddProductComplete();
      setChangeOrderLineUpdated(true);
      return;
    }
    if (user.isStaff) {
      if (onAddProduct && !onAddProduct()) {
        return;
      }
      const result = await addToCart({
        variables: {
          input: {
            contractId,
            userId,
            lines: getSelectedVariant().map(item => ({
              productId,
              contractMaterialId: contractMaterialId || undefined,
              quantity: item.quantity,
              variantId: item.id
            }))
          }
        }
      });
      setLoadingAddCart(false);
      if (result?.data?.createContractCheckout?.checkout?.id) {
        setTypeAlert("success");
        setOpenAlert(true);
        refetchCart().then(response => reCountCartDomestic(response));
        onAddProductComplete();
        onAutoClose();
      } else {
        setTypeAlert("error");
        setOpenAlert(true);
      }
    } else {
      if (staffUpdate === STAFF_UPDATE.UPDATE_CART) {
        const result = await updateCartCustomer({
          variables: {
            id: cartId,
            input: {
              lines: getSelectedVariant().map(item => ({
                productId,
                quantity: item.quantity,
                variantId: item.id
              }))
            }
          }
        });
        setLoadingAddCart(false);
        if (result?.data?.updateCustomerCart?.cart?.id) {
          setTypeAlert("success");
          setOpenAlert(true);
          refetchCartCustomer().then(response => reCountCartCustomer(response));
          onAddProductComplete();
          onAutoClose();
        } else {
          setTypeAlert("error");
          setOpenAlert(true);
        }
      } else if (staffUpdate === STAFF_UPDATE.UPDATE_ORDER) {
        const result = await addCustomerOrder({
          variables: {
            id: cartId,
            input: getSelectedVariant().map(item => ({
              cartItemId: cartId,
              contractProductId: dataCustomer.customerContractProduct.id,
              quantity: item.quantity,
              variantId: item.id
            }))
          }
        });
        setLoadingAddCart(false);
        if (result?.data?.addProductToCustomerOrder?.order?.id) {
          setTypeAlert("success");
          setOpenAlert(true);
          refetchCartCustomer().then(response => reCountCartCustomer(response));
          onAddProductComplete();
          onAutoClose();
        } else if (
          result?.data?.addProductToCustomerOrder?.errors[0]?.code ===
          "PRODUCT_GROUP_ERROR"
        ) {
          setVisibleDialogError(true);
          setPopUpContent(prodErrorContent);
        } else {
          setTypeAlert("error");
          setOpenAlert(true);
        }
      } else {
        const result = await creatCartCustomer({
          variables: {
            input: {
              soldToId,
              customerId: userId,
              customerContractId: contractId,
              lines: getSelectedVariant().map(item => ({
                productId,
                quantity: item.quantity,
                variantId: item.id
              }))
            }
          }
        });
        setLoadingAddCart(false);
        if (result?.data?.createCustomerCart?.cart?.id) {
          setTypeAlert("success");
          setOpenAlert(true);
          refetchCartCustomer().then(response => reCountCartCustomer(response));
          onAddProductComplete();
          onAutoClose();
        } else {
          setTypeAlert("error");
          setOpenAlert(true);
        }
      }
    }

    customerCartsRefetch();
  };

  const textError = intl.formatMessage({
    defaultMessage: "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ"
  });

  const tableLoading = loading || loadingCustomer;

  return (
    <>
      <SnackbarAlert
        severity={typeAlert}
        open={openAlert}
        onClose={handleCloseAlert}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <div className={classes.snackHeadTitle}>
          <MyTypography
            variant="subtitle2"
            style={{ color: "#ffffff", marginRight: "2px" }}
          >
            {staffUpdate === STAFF_UPDATE.UPDATE_ORDER ||
            staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC
              ? intl.formatMessage({
                  defaultMessage: "Added to order",
                  description: "dialog header"
                })
              : intl.formatMessage({
                  defaultMessage: "Added to cart",
                  description: "dialog header"
                })}
          </MyTypography>
          <MyTypography variant="body3" style={{ color: "#ffffff" }}>
            {typeAlert === "success"
              ? staffUpdate === STAFF_UPDATE.UPDATE_ORDER ||
                staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC
                ? "เพิ่มสินค้าในคำสั่งซื้อสำเร็จ"
                : "เพิ่มสินค้าลงตะกร้าสำเร็จ"
              : ""}
            {typeAlert === "error"
              ? staffUpdate === STAFF_UPDATE.UPDATE_ORDER ||
                staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC
                ? "เพิ่มสินค้าในคำสั่งซื้อไม่สำเร็จ"
                : "เพิ่มสินค้าลงตะกร้าไม่สำเร็จ"
              : ""}
          </MyTypography>
        </div>
      </SnackbarAlert>
      <Dialog
        open={open}
        className={classes.root}
        data-testid={testId ?? "modalProductDetail"}
      >
        <DialogTitle className={classes.dialogTitle}>
          <CloseOutlined
            className={classes.closeDialog}
            onClick={onClose}
            data-testid="closeButton"
          />
        </DialogTitle>
        <DialogContent dividers={false} className={classes.dialogContent}>
          <div className={classes.materialName}>
            {user.isStaff
              ? data?.contractProduct?.product?.name
              : dataCustomer?.customerContractProduct?.product?.descriptionEn}
          </div>
          <Grid container>
            <Grid item xs={6} md={3}>
              <div className={classes.detailTitle}>
                <FormattedMessage defaultMessage={"จำนวน"} />
              </div>
              <div>
                <DecimalFormat
                  value={
                    user.isStaff
                      ? data?.contractProduct?.total
                      : dataCustomer?.customerContractProduct?.totalQuantity
                  }
                  isGrayDecimal
                  countDecimal={3}
                />
              </div>
            </Grid>
            <Grid item xs={6} md={3}>
              <div className={classes.detailTitle}>
                <FormattedMessage defaultMessage={"คงเหลือ"} />
              </div>
              <div>
                <DecimalFormat
                  value={
                    user.isStaff
                      ? data?.contractProduct?.remain
                      : dataCustomer?.customerContractProduct?.remainingQuantity
                  }
                  isGrayDecimal
                  countDecimal={3}
                />
              </div>
            </Grid>
            <Grid item xs={6} md={3}>
              <div className={classes.detailTitle}>
                <FormattedMessage defaultMessage={"หน่วย"} />
              </div>
              <div className={classes.detailValue}>
                {user.isStaff
                  ? data?.contractProduct?.salesUnit
                  : dataCustomer?.customerContractProduct?.weightUnit}
              </div>
            </Grid>
            <Grid item xs={6} md={3}>
              <div className={classes.detailTitle}>
                <FormattedMessage defaultMessage={"ราคา"} />
                <span className={"normalText"}>
                  (
                  {user.isStaff
                    ? data?.contractProduct?.contract?.currency
                    : dataCustomer?.customerContractProduct?.contract?.currency}
                  )
                </span>
                {staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC ? (
                  <FormattedMessage defaultMessage={"/หน่วย"} />
                ) : (
                  <FormattedMessage defaultMessage={"ต่อหน่วย"} />
                )}
              </div>
              <div>
                <DecimalFormat
                  value={
                    user.isStaff
                      ? data?.contractProduct?.price
                      : dataCustomer?.customerContractProduct?.pricePerUnit
                  }
                />
              </div>
            </Grid>
          </Grid>
          <Table
            className={classNames(
              classes.tableRoot,
              tableLoading && classes.tableLoading
            )}
          >
            <TableHead>
              <TableRow>
                <TableCellHeader className={classes.cellCheckbox}>
                  <Checkbox
                    id="checkboxAll"
                    data-testid="checkboxAll"
                    size={"small"}
                    onClick={onClickCheckHeader}
                    checked={getCheckedHeader()}
                    indeterminate={getIndeterminateHeader()}
                  />
                </TableCellHeader>
                <TableCellHeader colSpan={2} className={classes.cellName}>
                  <FormattedMessage defaultMessage={"ตัวเลือกสินค้า"} />
                </TableCellHeader>
                <TableCellHeader
                  textAlign={"center"}
                  className={classes.cellInput}
                >
                  {staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC ||
                  staffUpdate === STAFF_UPDATE.UPDATE_ORDER ? (
                    <div className={classes.boldText}>
                      จำนวน <span className={classes.normalText}>(ม้วน)</span>
                    </div>
                  ) : (
                    <FormattedMessage defaultMessage={"จำนวน (ม้วน)"} />
                  )}
                </TableCellHeader>
              </TableRow>
              {tableLoading && (
                <TableRow>
                  <TableCell colSpan={4} className={classes.tableHeaderLoading}>
                    <LinearProgress data-testid="table-loading-progress" />
                  </TableCell>
                </TableRow>
              )}
            </TableHead>
            <TableBody>
              {!user.isStaff ? (
                <>
                  {!loadingCustomer &&
                    customerVariantStandard.length <= 0 &&
                    customerVariantNonStandard.length <= 0 && (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          className={classNames(
                            classes.variantName,
                            classes.cellName
                          )}
                          style={{ textAlign: "center" }}
                        >
                          {intl.formatMessage({
                            defaultMessage:
                              "ไม่พบข้อมูล Material ที่ผูกไว้ใน Contract"
                          })}
                        </TableCell>
                      </TableRow>
                    )}
                  {!loadingCustomer && customerVariantStandard.length > 0 && (
                    <>
                      {!isHideShowStandard && (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            className={classNames(
                              classes.variantName,
                              classes.cellName
                            )}
                          >
                            {intl.formatMessage({
                              defaultMessage: "สินค้า Standard ---------------"
                            })}
                          </TableCell>
                        </TableRow>
                      )}
                      {customerVariantStandard.map((variant, index) => (
                        <TableRow key={variant?.id}>
                          <TableCell
                            align={"center"}
                            className={classes.cellCheckbox}
                          >
                            <Checkbox
                              id={`customerVariantStandard[${index}].checkbox`}
                              data-testid={`customerVariantStandard[${index}].checkbox`}
                              size={"small"}
                              checked={variant.selected}
                              onChange={e => onChangeCheckItem(e, variant.id)}
                            />
                          </TableCell>
                          <TableCell
                            className={classNames(
                              classes.variantName,
                              classes.cellName
                            )}
                            colSpan={2}
                          >
                            {variant.descriptionEn}
                          </TableCell>
                          <TableCell
                            align={"center"}
                            className={classes.cellInput}
                          >
                            <NumberFormat
                              id={`customerVariantStandard[${index}].quantity`}
                              data-testid={`customerVariantStandard[${index}].quantity`}
                              error={variant.errorQuantity}
                              placeholder={"ระบุจำนวน"}
                              isReset={variant.reset}
                              onChange={e =>
                                onChangeQuantity(e.target.value, variant.id)
                              }
                              value={variant.quantity}
                              decimalScale={0}
                              allowLeadingZeros
                            />
                            {variant.errorQuantity && variant.quantity ? (
                              <div className={classes.textError}>
                                {textError}
                              </div>
                            ) : (
                              ""
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  )}
                  {!loadingCustomer && customerVariantNonStandard.length > 0 && (
                    <>
                      {!isHideShowStandard && (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            className={classNames(
                              classes.variantName,
                              classes.cellName
                            )}
                          >
                            {intl.formatMessage({
                              defaultMessage:
                                "สินค้า Non Standard ---------------"
                            })}
                          </TableCell>
                        </TableRow>
                      )}
                      {customerVariantNonStandard.map((variant, index) => (
                        <TableRow key={variant?.id}>
                          <TableCell
                            align={"center"}
                            className={classes.cellCheckbox}
                          >
                            <Checkbox
                              id={`customerVariantNonStandard[${index}].checkbox`}
                              data-testid={`customerVariantNonStandard[${index}].checkbox`}
                              size={"small"}
                              checked={variant.selected}
                              onChange={e => onChangeCheckItem(e, variant.id)}
                            />
                          </TableCell>
                          <TableCell
                            className={classNames(
                              classes.variantName,
                              classes.cellName
                            )}
                            colSpan={2}
                          >
                            {variant.descriptionEn}
                          </TableCell>
                          <TableCell
                            align={"center"}
                            className={classes.cellInput}
                          >
                            <NumberFormat
                              id={`customerVariantNonStandard[${index}].quantity`}
                              data-testid={`customerVariantNonStandard[${index}].quantity`}
                              error={variant.errorQuantity}
                              placeholder={"ระบุจำนวน"}
                              isReset={variant.reset}
                              onChange={e =>
                                onChangeQuantity(e.target.value, variant.id)
                              }
                              value={variant.quantity}
                              decimalScale={0}
                              allowLeadingZeros
                            />
                            {variant.errorQuantity && variant.quantity ? (
                              <div className={classes.textError}>
                                {textError}
                              </div>
                            ) : (
                              ""
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  )}
                </>
              ) : (
                <>
                  {!loading &&
                    splitedData.standard.length <= 0 &&
                    splitedData?.nonStandard?.length <= 0 && (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          className={classNames(
                            classes.variantName,
                            classes.cellName
                          )}
                          style={{ textAlign: "center" }}
                        >
                          {intl.formatMessage({
                            defaultMessage:
                              "ไม่พบข้อมูล Material ที่ผูกไว้ใน Contract"
                          })}
                        </TableCell>
                      </TableRow>
                    )}
                  {!loading && splitedData?.standard?.length > 0 && (
                    <>
                      {!isHideShowStandard && (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            className={classNames(
                              classes.variantName,
                              classes.cellName
                            )}
                          >
                            {intl.formatMessage({
                              defaultMessage: "สินค้า Standard ---------------"
                            })}
                          </TableCell>
                        </TableRow>
                      )}
                      {splitedData?.standard?.map((variant, index) => (
                        <TableRow key={variant.id}>
                          <TableCell
                            align={"center"}
                            className={classes.cellCheckbox}
                          >
                            <Checkbox
                              id={`splitedDataStandard[${index}].checkbox`}
                              data-testid={`splitedDataStandard[${index}].checkbox`}
                              size={"small"}
                              checked={variant.selected}
                              onChange={e => onChangeCheckItem(e, variant.id)}
                            />
                          </TableCell>
                          <TableCell
                            className={classNames(
                              classes.variantName,
                              classes.cellName
                            )}
                            colSpan={2}
                          >
                            {variant.descriptionEn}
                          </TableCell>
                          <TableCell
                            align={"center"}
                            className={classes.cellInput}
                          >
                            <NumberFormat
                              id={`splitedDataStandard[${index}].quantity`}
                              data-testid={`splitedDataStandard[${index}].quantity`}
                              error={variant.errorQuantity}
                              placeholder={"ระบุจำนวน"}
                              isReset={variant.reset}
                              onChange={e =>
                                onChangeQuantity(e.target.value, variant.id)
                              }
                              value={variant.quantity}
                              decimalScale={0}
                              allowLeadingZeros
                            />
                            {variant.errorQuantity && variant.quantity ? (
                              <div className={classes.textError}>
                                {textError}
                              </div>
                            ) : (
                              ""
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  )}

                  {!loading && splitedData?.nonStandard?.length > 0 && (
                    <>
                      {!isHideShowStandard && (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            className={classNames(
                              classes.variantName,
                              classes.cellName
                            )}
                          >
                            {intl.formatMessage({
                              defaultMessage:
                                "สินค้า Non Standard ---------------"
                            })}
                          </TableCell>
                        </TableRow>
                      )}
                      {splitedData.nonStandard.map((variant, index) => (
                        <TableRow key={variant?.id}>
                          <TableCell
                            align={"center"}
                            className={classes.cellCheckbox}
                          >
                            <Checkbox
                              id={`splitedDataNonStandard[${index}].checkbox`}
                              data-testid={`splitedDataNonStandard[${index}].checkbox`}
                              size={"small"}
                              checked={variant.selected}
                              onChange={e => onChangeCheckItem(e, variant.id)}
                            />
                          </TableCell>
                          <TableCell
                            className={classNames(
                              classes.variantName,
                              classes.cellName
                            )}
                            colSpan={2}
                          >
                            {variant.descriptionEn}
                          </TableCell>
                          <TableCell
                            align={"center"}
                            className={classes.cellInput}
                          >
                            <NumberFormat
                              id={`splitedDataNonStandard[${index}].quantity`}
                              data-testid={`splitedDataNonStandard[${index}].quantity`}
                              error={variant.errorQuantity}
                              placeholder={"ระบุจำนวน"}
                              isReset={variant.reset}
                              onChange={e =>
                                onChangeQuantity(e.target.value, variant.id)
                              }
                              value={variant.quantity}
                              decimalScale={0}
                              allowLeadingZeros
                            />
                            {variant.errorQuantity && variant.quantity ? (
                              <div className={classes.textError}>
                                {textError}
                              </div>
                            ) : (
                              ""
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  )}
                </>
              )}
            </TableBody>
          </Table>
          <div className={classes.textNumberSelect}>
            เลือก{/**/}
            <span className={classes.textNumber}>
              {getSelectedVariant().length}
            </span>
            {/**/}
            รายการ
          </div>
        </DialogContent>
        <DialogActions disableSpacing={true}>
          <Button
            id="modalProductDetail-clearButton"
            data-testid="modalProductDetail-clearButton"
            variant={"outlined"}
            color={"secondary"}
            className={classes.buttonAction}
            onClick={onClickClear}
            disabled={getDisableSubmit() || loadingAddCart || tableLoading}
          >
            <FormattedMessage defaultMessage={"Clear"} />
          </Button>
          <Button
            id="modalProductDetail-addToCartButton"
            data-testid="modalProductDetail-addToCartButton"
            variant={"contained"}
            color={"secondary"}
            className={classes.buttonAction}
            startIcon={<ShoppingCartOutlined />}
            onClick={onClickAddToCart}
            disabled={getDisableSubmit() || loadingAddCart || tableLoading}
          >
            {staffUpdate === STAFF_UPDATE.UPDATE_ORDER ||
            staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC ? (
              <FormattedMessage defaultMessage={"Add to order"} />
            ) : (
              <FormattedMessage defaultMessage={"Add to cart"} />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ModalProductDetail.displayName = "ModalProductDetail";
export default ModalProductDetail;
